/**
 * LOT-UI-03a — Classes partagées pour cohérence produit (tabs, chips, cartes).
 */

export const staffTabClass = (active) =>
  active
    ? 'px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2 whitespace-nowrap transition-all bg-[rgba(var(--theme-primary-rgb),0.15)] text-[var(--theme-primary)] border border-[rgba(var(--theme-primary-rgb),0.3)]'
    : 'px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2 whitespace-nowrap transition-all bg-white/5 text-gray-400 border border-white/10 hover:text-white hover:bg-white/10';

export const staffChipClass = (active) =>
  active
    ? 'px-3 py-1.5 rounded-lg text-xs font-semibold transition-all bg-[rgba(var(--theme-primary-rgb),0.15)] text-[var(--theme-primary)] border border-[rgba(var(--theme-primary-rgb),0.3)]'
    : 'px-3 py-1.5 rounded-lg text-xs font-semibold transition-all bg-white/5 text-gray-500 border border-white/10 hover:text-gray-300';

export const staffCardClass = 'rounded-xl border border-white/10 bg-white/5';

export const staffSecondaryBtnClass =
  'px-3 py-2 rounded-xl text-sm font-medium flex items-center gap-2 transition-colors border border-white/10 bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white';

export const staffInputClass =
  'w-full px-3 py-2.5 rounded-xl text-sm bg-white/5 text-white border border-white/10 placeholder:text-gray-500 outline-none focus:border-[rgba(var(--theme-primary-rgb),0.4)]';

export const staffTableWrapClass = `${staffCardClass} overflow-hidden`;

export const chartTooltipStyle = {
  background: 'rgba(17,17,17,0.95)',
  border: '1px solid rgba(255,255,255,0.1)',
  borderRadius: 12,
  color: '#f1f5f9',
  fontSize: 12,
};
